import { render, staticRenderFns } from "./SalesInvoiceStatusBadge.vue?vue&type=template&id=0e79c560&"
import script from "./SalesInvoiceStatusBadge.vue?vue&type=script&lang=js&"
export * from "./SalesInvoiceStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports